import React from 'react';
import HostgroupJobs from './HostgroupJobs';

export default [
  {
    path: '/ansible/hostgroups/:id',
    render: props => <HostgroupJobs {...props} />,
    exact: true,
  },
];



// WEBPACK FOOTER //
// ./vendor/ruby/2.7.0/gems/foreman_ansible-12.0.6/webpack/routes/routes.js